import React, { Component, Fragment } from 'react';

export default class UserInput extends React.Component
{		

	static get defaultProps() 
	{

		var defaultdata = {} ;

		defaultdata.className = 'input-group' ;

	    var v =
    	{
    	} ;

    	return v ;
	}
	
	constructor(props) 
	{
		super(props);
		
        this.handleInputChange = this.handleInputChange.bind(this, this.props.id);
        this.focus = this.focus.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
		
		this.keyCount = 0 ;

		let v = this.props.value ;

		if ( v == null )
		{
			v = '' ;
		}

    	// Create a state item here for all items on the form  (Using their id )
		this.state = {
				val: v,
				dirty: false, 
				valid: this.isValueValid(v),
				types: null,
			cursorStart: 0,
			cursorEnd: 0
		};
		
	}

	onDateChange ( date, obj )
	{
		console.log ("Changed");
		
	    //var select = $(ReactDOM.findDOMNode(this)).find('input');
	    
	   // $(select).datepicker( "option", "currentText", "Now" );
		
		if ( this.props.onDateSelect != null )
		{
			this.props.onDateSelect( date );
		}
	
		this.setState ( {val: date, dirty: true } ) ;
	}

    sendChangeNotification()
    {
        if ( this.state.dirty == false )
        {
            if ( this.props.onDirty != null )
            {
                // Send a dirty notification if required, and only the first time we change
                this.props.onDirty() ;
            }
        }
    }

    handleInputChange(propertyName, event)
    {
        var isValid = true ;

        if ( event.target != null )
        {
			let cursorStart = event.target.selectionStart;
			let cursorEnd = event.target.selectionEnd;

            if ( this.props.validation.maxlen != null )
            {
                if ( event.target.value.length <= this.props.validation.maxlen )
                {
                    isValid = this.isValueValid(event.target.value) ;

                    this.sendChangeNotification() ;

                    this.setState({ cursorStart: cursorStart, cursorEnd: cursorEnd, val: event.target.value, dirty: true, valid: isValid });
                }
            }
            else
            {
                isValid = this.isValueValid(event.target.value) ;

                this.sendChangeNotification() ;

                this.setState({ cursorStart: cursorStart, cursorEnd: cursorEnd, val: event.target.value, dirty: true, valid: isValid });
            }
        }
    }

	componentDidMount()
	{
		if ( !this.isReadOnly())
		{
			if ( this.props.isDate == true )
			{
			    var select = $(ReactDOM.findDOMNode(this)).find('#'+this.props.id);
			    
			    var id = select[0].id ;
			       
			    $(select).datepicker({
			        changeYear: true,
			        dateFormat: 'dd/mm/yy',
			        onSelect: this.onDateChange,
			        defaultDate: this.state.val
			    }) ;
			}
			else
			{
				if ( this.props.validation != null )
				{
					if ( this.props.validation.isDate == true )
					{
					    select = $(ReactDOM.findDOMNode(this)).find('#'+this.props.id);
					    
					    var id = select[0].id ;
					       
					    $(select).datepicker({
					        changeYear: true,
					        dateFormat: 'dd/mm/yy',
					        onSelect: this.onDateChange,
					        defaultDate: this.state.val
					    }) ;
					}
				}
			}
		}
	}

	componentDidUpdate(prevProps, prevState)
	{
		if ( this.props.readOnly != prevProps.readOnly)
		{
			if ( this.props.validation.isDate == true )
			{
				var select = $(ReactDOM.findDOMNode(this)).find('#'+this.props.id);

				var id = select[0].id ;

				if ( this.props.readOnly == 'readonly')
				{
					$(select).datepicker("destroy") ;
				}
				else
				{
					$(select).datepicker({
						changeYear: true,
						dateFormat: 'dd/mm/yy',
						onSelect: this.onDateChange,
						defaultDate: this.state.val
					}) ;
				}
			}
		}

		this.refs.inputReference.setSelectionRange(this.state.cursorStart, this.state.cursorEnd) ;
	}
	
    /**
     * Sets the initial 'valid' state and value when the initial props are supplied
     * 
     * @param {props} nextProps - props object passed by React.
     * @return {void} 
     */
	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps.value != this.props.value )
		{
			var isValid = this.isValueValid(nextProps.value) ;
		
			// Set our initial validity state
			this.setState ( 
					{ 
						val: nextProps.value, 
						valid: isValid 
					}) ;
		}
	}

	isReadOnly()
	{
		var rval = false ;

		if ( this.props.readOnly == 'readonly' || this.props.readonly == true)
    	{
			rval = true ;
    	}		
		
		return rval ;
	}

	
	isValidEmail(emailAddress)
	{
		var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
		var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
		var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
		var sQuotedPair = '\\x5c[\\x00-\\x7f]';
		var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
		var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
		var sDomain_ref = sAtom;
		var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
		var sWord = '(' + sAtom + '|' + sQuotedString + ')';
		var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
		var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
		var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
		var sValidEmail = '^' + sAddrSpec + '$'; // as whole string
		
		var reValidEmail = new RegExp(sValidEmail);
		
		return reValidEmail.test(emailAddress);
	}
	
	// Validates that the input string is a valid date formatted as "mm/dd/yyyy"
	isValidDate(dateString)
	{
	    // First check for the pattern
	    if(!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString))
	        return false;

	    // Parse the date parts to integers
	    var parts = dateString.split("/");
	    var day = parseInt(parts[0], 10);
	    var month = parseInt(parts[1], 10);
	    var year = parseInt(parts[2], 10);

	    // Check the ranges of month and year
	    if(year < 1000 || year > 3000 || month == 0 || month > 12)
	        return false;

	    var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

	    // Adjust for leap years
	    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
	        monthLength[1] = 29;

	    // Check the range of the day
	    return day > 0 && day <= monthLength[month - 1];
	};
	

	


    /**
     * Returns true if the input value complies with currency validation rules.
     * 
     * Accepts : nnnn, nnn.nn, nnn.n
     * @param {string} numStr - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValidTime(numStr)
	{	
		var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
		
		return regex.test(numStr) ;
	}

    /**
     * Returns true if the input value complies with currency validation rules.
     * 
     * Accepts : nnnn, nnn.nn, nnn.n
     * @param {string} numStr - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValidCurrency(numStr)
	{	
		var regex = /^\£?[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
		
		return regex.test(numStr) ;
	}
	
	    /**
     * Returns true if the input value complies with currency validation rules.
     * 
     * Accepts : nnnn, nnn.nn, nnn.n
     * @param {string} numStr - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValidInteger(numStr)
	{	
		var regex = /^[0-9]+$/;
		
		return regex.test(numStr) ;
	}

	/**
	 * Returns true if the input value complies with currency validation rules.
	 *
	 * Accepts : nnnn, nnn.nn, nnn.n
	 * @param {string} numStr - The value of the string to be tested.
	 * @return {bool} true if the test passes.
	 */
	isValidFloat(numStr)
	{
		var regex = /^[+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;

		return regex.test(numStr) ;
	}

    /**
     * Returns true if the input value complies with currency validation rules.
     * 
     * Accepts : nnnn, nnn.nn, nnn.n
     * @param {string} numStr - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValidPercentage(numStr)
	{	
		var regex = /^[0-9]+$/;
		
		if ( regex.test(numStr))
		{
			var n = Number(numStr) ;
			
			if ( n <= 100 && n >= 0 )
			{
				return true ;
			}
		}

		return false ;
	}

	isValidPassword( text )
	{
		var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])^[a-zA-Z0-9!@\-_#$%]+$/;
		
	    var t = re.test(text)&&text.length>7;

	    return t ;
	}	
	
	isValidPostcode ( text )
	{
		var re = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/ ;
		
		return re.test(text) ;
	}
	
	isValidTelephone ( text ) 
	{
		var re = /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/;		

		return re.test(text) ;		
	}

	isValidGender ( text )
	{
		if ( text == 'M' || text == 'm' || text == 'F' || text == 'f' )
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

    /**
     * Returns true if the input value complies with the validation rules supplied
     * 
     * @param {string} param - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValueValid( param )
	{
		if ( this.props.validation.required == true )
		{
			if ( param == null || param == "")
			{
				return false ;
			}
		}
		else
		{
			if ( param == null || param == "")
			{
				// If not required, and empty, it's OK
				return true ;
			}
		}
		
		if ( this.props.validation.isDate == true )
		{
			if ( !this.isValidDate(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.isTime == true )
		{
			if ( !this.isValidTime(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.isInteger == true )
		{
			if ( !this.isValidInteger(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.isFloat == true )
		{
			if ( !this.isValidFloat(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.nonZero == true )
		{
			if ( param == 0)
			{
				return false ;
			}
		}
		
		if ( this.props.validation.isCurrency == true )
		{
			if ( !this.isValidCurrency(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.isGender == true )
		{
			if ( !this.isValidGender(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.isEmail == true )
		{
			if ( !this.isValidEmail(param))
			{
				return false ;
			}
		}
		
		if ( this.props.validation.isPostcode == true )
		{
			if ( !this.isValidPostcode(param))
			{
				return false ;
			}
		}

		if ( this.props.validation.isTelephone == true )
		{
			if ( !this.isValidTelephone(param))
			{
				return false ;
			}
		}
		
		if ( this.props.validation.isPassword == true )
		{
			if ( !this.isValidPassword(param))
			{
				return false ;
			}
		}

		return true ;
	}
	

	
    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	isValid()
	{
		var v = this.getValue() ;
		
		return this.isValueValid ( v ) ;
	}

    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	isDirty()
	{		
		return this.state.dirty ;
	}
	
    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	setDirty( value )
	{		
		this.setState ({ dirty: value }) ;
	}

	
	stripTrail ( inputvalue )
	{
		if ( inputvalue != null )
		{
			if (typeof inputvalue === 'string' || inputvalue instanceof String)
			{
				return inputvalue.trim();					
			}
			else
			{
				return inputvalue ;
			}
		}
		else
		{
			return inputvalue ;
		}
	}
	
	getFormattedDate(date) 
	{
		  var year = date.getFullYear();
		  var month = (1 + date.getMonth()).toString();
		  month = month.length > 1 ? month : '0' + month;
		  var day = date.getDate().toString();
		  day = day.length > 1 ? day : '0' + day;
		  return day + '/' + month + '/' + year;
	}
	/**
     * External function to return the value of the input field
     * 
     * @return {string} THe value of the input field.
     */
	getValue()
	{
		if ( this.state.val != null )
		{
			var v = String(this.state.val) ;

			if ( this.props.validation.isCurrency == true )
			{			
				if ( v.length > 1 )
				{
					if ( v.substr(0,1) == '£' )
					{
						v = v.substr(1,(v.length)-1) ;
						return this.stripTrail(v) ;
					}
					else
					{
						return this.stripTrail(v) ;			 		
					}			
				}
				else
				{
					return this.stripTrail(v) ;					
				}			
			}
			else if ( this.props.validation.isPostcode == true )
			{
				return this.stripTrail(v.toUpperCase());			
			}
			else
			{
				return this.stripTrail(v) ;		
			}		
		}
		else
		{
			return null ;
		}
	}
	
    /**
     * Generates HTML for the error DIV which wil be visible if the field contents are
     * invalid AND the this.props.displayErrors flag is set. This will generally be set 
     * by the parent form if error display is required.
     * 
     * @param {bool} validFlag - True if this field is currnetly invalid.
     * @return {void} 
     */
	errorDiv ()
	{
		var errmsg = "&nbsp;";
		
		if ( this.props.errorText != null )
		{
			if ( this.props.errorText.length != 0)
			{
				errmsg = this.props.errorText ;
			}
		}

		var className = 'input-error-invisible' ;
		
		if ( this.props.displayErrors == true && ( this.isValid() != true || this.shouldForceErrorDisplay()) )
		{
			className = 'input-error-visible' ;
		}

		if ( this.props.validation.isPassword == true )
		{
			if ( this.props.passwordMismatch == true )
		    {
				className = 'input-error-visible' ;
		    }
	    }
		
		return React.createElement ('div', {  htmlFor: this.props.id, key: this.keyCount++, className: className} , errmsg ) ;		
	}
	
	shouldForceErrorDisplay ()
	{
		// Additional test to force an error display externally, even if this field isn't actually invalid.
		// This can be used, for example to display a form error

		if ( this.props.validation != null )
		{
			if ( this.props.validation.forceError == true)
			{
				return true ;
			}
		}
		
		return false ;
	}
	
	
	inputCollection ()
	{ 
        var lineList=[];
        
        var v = this.state.val ;
        
        if ( v == null )
    	{
        	v = '';
    	}

        if ( this.props.labelText != null)
    	{
            lineList.push (React.createElement('label', { style: {marginBottom: '5px'}, key: this.keyCount++, htmlFor: this.props.id, className: 'col-2 col-form-label'}, this.props.labelText ));
    	}
        
        let className = 'form-control' ;
        let style = {} ;
        let type = 'text' ;

        if ( this.props.isPassword == true )
    	{
        	type = 'password' ;
    	}
        
        if ( this.props.className != null )
        {
        	className = this.props.className ;
    	}

    	if ( this.props.style != null )
		{
    		style = this.props.style ;
		}

        if ( this.isReadOnly())
    	{
        	style.borderColor = '#d8e5ed';
        	style.paddingLeft = '14px';
        	style.color = '#428bcd';
        	style.marginBottom = '10px';
    	}

        if ( this.props.displayErrors == true && !this.isValid())
    	{
           	style.borderColor = '#ff0000' ;
    	}

        let autofocus = '' ;

        if ( this.props.autofocus == true )
		{
			autofocus = true ;
		}

        let props = {
			ref: 'inputReference',
			key: this.props.id + this.keyCount++,
			readOnly: this.props.readOnly,
			className: className,
			autoFocus: autofocus,
			type: type,
			value:v,
			style: style,
			tabIndex: this.props.tabIndex,
			id: this.props.id,
			name: this.props.name,
			placeholder: this.props.placeholder,
			onBlur: this.props.onBlur,
			onChange: this.handleInputChange
		} ;

		if ( this.props.validation.isDate == true )
		{
			props.autoComplete= "nope" ;
		}
		else if ( this.props.autoComplete != null)
		{
			props.autoComplete= this.props.autoComplete ;
		}

        lineList.push ( React.createElement('input',props)) ;
        
        if ( this.props.displayErrors == true  && ( !this.isValid() || this.shouldForceErrorDisplay()))
    	{
            lineList.push ( this.errorDiv() ) ;    	
    	}
        
        return lineList ;
	}
	
	renderedComponent()
	{
    	return React.createElement ('div', {  key: this.props.keyValue, className: this.props.containerClassName }, this.inputCollection());
		
	}
	
	focus ()
	{
		 this.refs.inputReference.focus() ;		
	}
	
    render() 
    {
    	this.keyCount = 0 ;

    	return this.renderedComponent() ;    	
    }
};
